import _ from "lodash";
import React from "react";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { StandardTableSortablePropertyHeader } from "../../components/tables/StandardTable";
import useClientServiceLevelAgreements from "./hooks/useClientServiceLevelAgreements";
import ClientServiceLevelAgreementDetailedTableRow from "./components/ClientServiceLevelAgreementsDetailTableRow"

const ServiceTermsManagementDetailed = () => {
    
    const {
            clear: refreshTable,
            loadMore,
            isRowLoaded,
            sort,
            sortTable,
            results,
            totalCount,
            error,
            isNextPageLoading,
            isError,
    } = useClientServiceLevelAgreements();

    return (
        <React.Fragment>           
            <VirtualTable
                enableScrollTracking={false}
                row={ClientServiceLevelAgreementDetailedTableRow}
                header={
                    <thead>
                        <tr>
                            <StandardTableSortablePropertyHeader
                                property="masterAccount"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Master Account
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="adviser"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Adviser
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="serviceLevelAgreementStatus"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                SLA Status
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="serviceLevelAgreementStatusDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Status Date
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="anniversary"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Anniversary
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="consentPublishedDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Published Date
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="consentSignedDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Signed Date
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="latestReviewDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Last Review
                            </StandardTableSortablePropertyHeader>
                        </tr>
                    </thead>
                }
                footer={
                    <TableRecordCountDisplayFooter 
                        totalCount={totalCount}
                        isNewRecordsDisplayed={false}
                        newRecordsSinceCache={0}
                        reload={refreshTable}
                        spanLeft={5}
                    />
                }
                error={error}
                isLoading={isNextPageLoading}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={50}
                itemCount={totalCount}
                itemData={results}
            />
        </React.Fragment>
    );
};

export default ServiceTermsManagementDetailed;
